import ProjectCheckpointPreviewCard from './components/ProjectCheckpointPreviewCard'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import { useProjectCheckpointInstances } from './hooks/useProjectCheckpointInstances'
import useSelfActiveProject from 'screens/Projects/hooks/useSelfActiveProject'
import useActiveProjectTeam from './hooks/useActiveProjectTeam'
import { ReactComponent as HandIcon } from 'assets/icons/hand-regular.svg'

const ProjectCheckpoints = () => {
  const activeProject = useSelfActiveProject()
  const activeTeam = useActiveProjectTeam()

  const teamId = activeTeam?.id

  const { instances, loading } = useProjectCheckpointInstances(activeProject?.id, teamId)

  if (!activeProject) return <div>Проект не выбран</div>

  if (loading) return <div>Загрузка...</div>

  return (
    <TopNavigationLayoutPageContent type='default'>
      <div className='auto-grid-min-300'>
        {instances.length > 0 ? (
          instances.map((checkpointInstance, index) => (
            <ProjectCheckpointPreviewCard
              key={checkpointInstance.id}
              checkpointInstance={checkpointInstance}
              index={index}
            />
          ))
        ) : (
          <div
            className='flex-page-center'
            style={{ gridColumn: '1 / -1', minHeight: '280px', flexDirection: 'column', textAlign: 'center' }}
          >
            <HandIcon style={{ height: '72px', width: '72px', color: 'var(--secondary)', marginBottom: '12px' }} />
            <p className='text--body-l text--blue' style={{ marginBottom: '6px' }}>
              Контрольные точки пока не определены
            </p>
            <p className='text--body-m'>Появятся чуть позже - как только наставники их добавят.</p>
          </div>
        )}
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default ProjectCheckpoints
